import React, { useState, useContext, useRef, useEffect } from "react";
import axios from "axios";
import Resizer from "react-image-file-resizer";
import { ProductContext } from "../App";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

function AddStock() {
  const product_context = useContext(ProductContext);
  const { confirmDialogue, setConfirmDialogue, alert, setAlert, setIsLoading } =
    product_context;

  const [sizeAdded, setSizeAdded] = useState(true);

  const [image, setImage] = useState([]);

  const handleImageChange = async (e) => {
    try {
      const file = e.target.files[0];
      const resizedimage = await resizeFile(file);
      setImage([...image, resizedimage]);
      e.target.value = null;
    } catch (error) {
      setAlert({
        isOpen: true,
        message: "Something went wrong",
        type: "danger",
      });
    }
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
  };

  const [sizeInp, setSizeInp] = useState([""]);
  let size = 0;
  sizeInp.forEach((sizeInp) => {
    if (sizeInp !== "") {
      size += 1;
    }
  });

  const sizeRef = useRef(null);
  const InputRef = useRef(null);

  useEffect(() => {
    sizeRef.current && sizeRef.current.focus();
  }, [sizeAdded]);

  useEffect(() => {
    InputRef.current && InputRef.current.focus();
  }, []);

  const addInputSize = () => {
    const size = [...sizeInp, []];
    setSizeInp(size);
    setSizeAdded(!sizeAdded);
  };
  const handleChangeSize = (value, i) => {
    const inputdataSize = [...sizeInp];
    inputdataSize[i] = value.target.value.toUpperCase();
    setSizeInp(inputdataSize);
  };
  const handleRemoveSize = (e, i) => {
    let deletedataSize = [...sizeInp];
    deletedataSize.splice(i, 1);
    setSizeInp(deletedataSize);
    e.preventDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    document.body.classList.add("remove-scroll");
    let seller_name = e.target.sellerName.value;
    if (!seller_name) {
      seller_name = "Dream Closet";
    }
    let data = {
      seller_name: seller_name,
      item_name: e.target.itemName.value,
      item_type: e.target.itemType.value,
      price: e.target.price.value,
      color: e.target.color.value,
      size: sizeInp.filter((el) => el.trim() !== ""),
      additional_price: e.target.additional_price.value,
      quantity: size,
      total_in_hand:
        size * (e.target.price.value * 1 + e.target.additional_price.value * 1),
      image: image,
    };
    setConfirmDialogue({
      isOpen: true,
      data: data,
      message: "Do you want to continue?",
      submitHandle: () => {
        actualSubmit(data, e);
      },
    });
  };
  const actualSubmit = (data, e) => {
    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_SERVER_DOMAIN}/products`, data)
      .then((res) => {
        setAlert({
          isOpen: true,
          message: "Product Inserted",
          type: "success",
        });
        setIsLoading(false);
        setImage([]);
        e.target.reset();
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: err.response.data?.msg,
          type: "danger",
        });
        setIsLoading(false);
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    setConfirmDialogue({ ...confirmDialogue, isOpen: false });
  };

  return (
    <>
      <div>
        <div className="add-items">
          <h1>Add Items</h1>
          <form onSubmit={handleSubmit}>
            <div className="inputs">
              <label htmlFor="sellerName">Seller Name</label>
              <input
                ref={InputRef}
                type="text"
                placeholder="Enter Seller Name"
                name="sellerName"
              />
            </div>
            <div className="inputs">
              <label htmlFor="itemType">Item Type</label>
              <select
                className="form-select"
                name="itemType"
                aria-label="Default select example"
              >
                {product_context.productType.map((type, i) => {
                  return (
                    <option key={i} value={type}>
                      {type}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="inputs">
              <label htmlFor="itemName">Item Name</label>
              <input
                required
                type="text"
                placeholder="Enter Item Name"
                name="itemName"
              />
            </div>
            <div className="inputs">
              <label htmlFor="color">Color</label>
              <input
                required
                type="text"
                placeholder="Enter Color"
                name="color"
              />
            </div>
            <div className="inputs">
              <label htmlFor="price">Price</label>
              <input type="number" placeholder="Enter Price" name="price" />
            </div>
            <div className="inputs">
              <label htmlFor="additional_price">Additinal Price</label>
              <input
                type="number"
                placeholder="Enter Price"
                name="additional_price"
              />
            </div>
            <div className="inputs">
              <label htmlFor="image">Image</label>
              <div className="d-flex">
                {image.map((img, i) => {
                  return (
                    <div key={i} className="show-image mx-3">
                      <CloseIcon
                        onClick={(e) => {
                          let deletedimg = [...image];
                          deletedimg.splice(i, 1);
                          setImage(deletedimg);
                          e.preventDefault();
                        }}
                        className="fa-solid fa-xmark"
                      ></CloseIcon>
                      <img className="edit-image" src={img} alt="..." />
                    </div>
                  );
                })}
              </div>
              <input
                onChange={(e) => {
                  handleImageChange(e);
                }}
                multiple
                type="file"
                placeholder="Select Image"
                name="image"
                accept=".jpg, .jpeg, .png, .heic, .HEIC"
              />
            </div>
            <div className="inputs small">
              <label htmlFor="size">Size</label>
              <div id="sizes" className="d-flex">
                {sizeInp.map((size, i) => {
                  return (
                    <div className="list" key={i}>
                      <input
                        ref={sizeRef}
                        className="mt-2"
                        placeholder="Size"
                        type="text"
                        key={i}
                        value={size}
                        onChange={(e) => handleChangeSize(e, i)}
                      />
                      <DeleteIcon
                        className="fa-solid fa-trash remove-button"
                        onClick={(e) => handleRemoveSize(e, i)}
                      ></DeleteIcon>
                    </div>
                  );
                })}
              </div>
              <AddIcon
                onClick={() => addInputSize()}
                className="fa-solid fa-plus add-button"
              ></AddIcon>
            </div>
            <div className="text-center">
              <button
                className="btn btn-primary text-center mb-5"
                type="submit"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default AddStock;

const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      200,
      200,
      "JPEG",
      70,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });
